import React from "react";

export const Plus = (): JSX.Element => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="true"
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 12 13"
    >
      <path d="M10 6.454c0 .3-.2.5-.5.5h-3v3c0 .3-.2.5-.5.5s-.5-.2-.5-.5v-3h-3c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h3v-3c0-.3.2-.5.5-.5s.5.2.5.5v3h3c.3 0 .5.2.5.5z" />
    </svg>
  );
};
